// automatically generated by the FlatBuffers compiler, do not modify

import * as NS115100186165309685 from "./Types";
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.resource{
export class Resource {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns Resource
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Resource {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Resource= obj
 * @returns Resource
 */
static getRootAsResource(bb:flatbuffers.ByteBuffer, obj?:Resource):Resource {
  return (obj || new Resource()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Resource= obj
 * @returns Resource
 */
static getSizePrefixedRootAsResource(bb:flatbuffers.ByteBuffer, obj?:Resource):Resource {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Resource()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue
 */
standardAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
standardAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns number
 */
droppedAttributesCount():number {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startResource(builder:flatbuffers.Builder) {
  builder.startObject(2);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset standardAttributesOffset
 */
static addStandardAttributes(builder:flatbuffers.Builder, standardAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, standardAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createStandardAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startStandardAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param number droppedAttributesCount
 */
static addDroppedAttributesCount(builder:flatbuffers.Builder, droppedAttributesCount:number) {
  builder.addFieldInt32(1, droppedAttributesCount, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endResource(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createResource(builder:flatbuffers.Builder, standardAttributesOffset:flatbuffers.Offset, droppedAttributesCount:number):flatbuffers.Offset {
  Resource.startResource(builder);
  Resource.addStandardAttributes(builder, standardAttributesOffset);
  Resource.addDroppedAttributesCount(builder, droppedAttributesCount);
  return Resource.endResource(builder);
}
}
}
